import moment, { Moment } from 'moment';
import * as Yup from 'yup';

// USER MANAGEMENT

export const loginSchema = Yup.object().shape({
  username: Yup.string()
    .required('Please input Username')
    .matches(/^\S*$/, 'Blank space is not allowed')
    .label('Username'),
  password: Yup.string().required('Please input Password').label('Password'),
});

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email()
    .required('Please input valid Email')
    .label('Email'),
});

export const newPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required('Please input New Password')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      'Password must have at least eight characters, including one lowercase and one uppercase letter',
    )
    .label('New Password'),
  verifyPassword: Yup.string()
    .required('Please input Confirm Password')
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .label('Confirm Password'),
});

export const userRegistrationSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, 'Only letters and are allowed')
    .required('Please input First Name')
    .label('First Name'),
  lastName: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, 'Only letters are allowed')
    .required('Please input Last Name')
    .label('Last Name'),
  middleName: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, 'Only letters are allowed')
    .label('Middle Name'),
  email: Yup.string()
    .email('Please input a valid Email')
    .required('Please input Email')
    .label('Email'),
  contactNumber: Yup.string()
    // .matches(
    //   /^[9]\d{9}$/,
    //   'Contact Number must start with 9 and be 10 digits long',
    // )
    .required('Please input Contact Number')
    .label('Contact Number'),
  username: Yup.string()
    .required('Please input Username')
    .matches(/^\S*$/, 'Blank space is not allowed')
    .label('Username'),
  // password: Yup.string()
  //   .required("Please input Password")
  //   .matches(
  //     /^(?=.*[0-9].*[0-9])(?=.*[^a-zA-Z0-9].*[^a-zA-Z0-9]).{6,}$/,
  //     "Password must have at least 6 characters, including 2 numbers and 2 special characters"
  //   )
  //   .label("New Password"),
  password: Yup.string()
    .required('Please input Password')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      'Password must have at least eight characters, including one lowercase and one uppercase letter',
    )
    .label('New Password'),
  confirmPassword: Yup.string()
    .required('Please input Confirm Password')
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .label('Confirm Password'),
  securityCode: Yup.string()
    .required('Please input Security Code')
    .matches(/^\d{8}$/, 'Security Code must be 8 digits long')
    .label('Security Code'),
  confirmSecurityCode: Yup.string()
    .required('Please input Confirm Security Code')
    .oneOf([Yup.ref('securityCode')], 'Security Codes must match')
    .label('Confirm Security Code'),
  // department: Yup.string()
  //   .required("Please select Department")
  //   .label("Department"),
});

export const adminUserRegistrationSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, 'Only letters are allowed')
    .required('Please input First Name')
    .label('First Name'),
  lastName: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, 'Only letters are allowed')
    .required('Please input Last Name')
    .label('Last Name'),
  email: Yup.string()
    .email('Please input a valid Email')
    .required('Please input Email')
    .label('Email'),
  contact: Yup.string()
    // .matches(
    //   /^[9]\d{9}$/,
    //   'Contact Number must start with 9 and be 10 digits long',
    // )
    .required('Please input Contact Number')
    .label('Contact Number'),
  isActive: Yup.boolean().default(false).required().label('Is Active'),
  properties: Yup.array()
    .of(
      Yup.object().shape({
        property: Yup.object().shape({
          label: Yup.string().required('property is required'),
          value: Yup.string().required('property is required'),
        }),
        role: Yup.object().shape({
          label: Yup.string().required('role is required'),
          value: Yup.string().required('role is required'),
        }),
      }),
    )
    .required('Properties are required'),
  // postingLimit: Yup.number()
  //   .required("Please input Posting Limit")
  //   .label("Posting Limit"),
  // position: Yup.string().required("Please select Position").label("Position"),
  // middleName: Yup.string()
  //   .required("Please input Middle Name")
  //   .label("Middle Name"),
  // department: Yup.string()
  //   .required("Please select Department")
  //   .label("Department"),
  // properties: Yup.array()
  //   .min(1)
  //   .of(
  //     Yup.object().shape({
  //       isActive: Yup.boolean(),
  //       role: Yup.string(),
  //     })
  //   )
  // .test(
  //   "required",
  //   "The first property should not be null or undefined.",
  //   function (value) {
  //     if (value && value.length > 0) {
  //       const firstProperty = value[0];

  //       if (
  //         firstProperty === null ||
  //         firstProperty === undefined ||
  //         !!firstProperty
  //       ) {
  //         return this.createError({
  //           path: this.path,
  //           message: "Please select property to assign",
  //         });
  //       }
  //     }
  //     return true;
  //   }
  // )
  // .label("Properties"),
});

export const roleSchema = Yup.object().shape({
  roleDescription: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, 'Only letters are allowed')
    .required('Please input Role Description')
    .label('Role Description'),
  level: Yup.string().required('Please input Role Level').label('Role Level'),
  isActive: Yup.boolean().required('').label('Is Active'),
});

export const userAuthenticationSchema = Yup.object().shape({
  username: Yup.string()
    .required('Please input Username')
    .matches(/^\S*$/, 'Blank space is not allowed')
    .label('Username'),
  password: Yup.string()
    .required('Please input Password')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      'Password must have at least eight characters, including one lowercase and one uppercase letter',
    )
    .label('New Password'),
  securityCode: Yup.string()
    .required('Please input Security Code')
    .matches(/^\d{8}$/, 'Security Code must be 8 digits long')
    .label('Security Code'),
});

export const dialogChangePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .required('Current Password is a required field.')
    .label('Current Password'),
  newPassword: Yup.string()
    .required('New Password is a required field.')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      'Password must have at least eight characters, including one lowercase and one uppercase letter',
    )
    .notOneOf(
      [Yup.ref('currentPassword')],
      'New Password cannot be the same as Current Password',
    )
    .label('New Password'),
  confirmPassword: Yup.string()
    .required('Confirm Password is a required field.')
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
    .label('Confirm Password'),
});

// export const dialogChangeSecCodeSchema = Yup.object().shape({
//   currentSecurityCode: Yup.string()
//     .required('Current Security Code is required field')
//     .label('Current Security Code'),
//   newSecurityCode: Yup.string().required().label('New Security Code'),
//   confirmSecurityCode: Yup.string()
//     .required('Confirm Security Code is required field')
//     .oneOf([Yup.ref('newSecurityCode')], 'Security Code must match')
//     .label('Confirm Security Code'),
// });

export const dialogChangeSecCodeSchema = Yup.object().shape({
  currentSecurityCode: Yup.string()
    .required('Current Security Code is required field')
    .label('Current Security Code'),

  newSecurityCode: Yup.string()
    .required('New Security Code is required field')
    .matches(/^\d{8}$/, 'Security Code must be exactly 8 digits')
    .test(
      'not-all-same',
      'Security Code cannot have all digits the same',
      (value) => (value ? !/^(\d)\1{7}$/.test(value) : true),
    )
    .test(
      'no-3-consecutive-or-same',
      'Security Code cannot contain 3 consecutive increasing, decreasing, or identical numbers',
      (value) => {
        if (!value) return true;
        for (let i = 0; i < value.length - 2; i++) {
          const a = Number(value[i]);
          const b = Number(value[i + 1]);
          const c = Number(value[i + 2]);

          // 3 increasing numbers (e.g., 123)
          const isIncreasing = b === a + 1 && c === b + 1;
          // 3 decreasing numbers (e.g., 321)
          const isDecreasing = b === a - 1 && c === b - 1;
          // 3 same numbers (e.g., 111)
          const isSame = a === b && b === c;

          if (isIncreasing || isDecreasing || isSame) {
            return false;
          }
        }
        return true;
      },
    )
    .label('New Security Code'),

  confirmSecurityCode: Yup.string()
    .required('Confirm Security Code is required field')
    .oneOf([Yup.ref('newSecurityCode')], 'Security Code must match')
    .label('Confirm Security Code'),
});

export const dialogRequestForTrainingSchema = Yup.object().shape({
  preferredDate: Yup.mixed<Moment>()
    .test('is-moment', 'Invalid date', (value) => moment.isMoment(value))
    .required()
    .label('Preferred Date'),
  remarks: Yup.string().default('').label('Remarks'),
});

// GLOBAL

export const isValidMoment = () => {
  return Yup.mixed().test('is-valid-moment', 'Invalid date', (value) => {
    if (value == null) return true;
    return moment.isMoment(value) && value.isValid();
  });
};
